import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import moment from 'moment';

//Material Components
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

import { AddDining, UpdDining, AddDiningImage } from '../../actions/diningActions';
import { GetPixabyImages, ClearImages } from '../../actions/imageActions';


//Engage Components
import {
    renderTextField, renderActivitySwitch, renderSingleDatePicker, renderTextFieldWithChips,
    RenderImageLoaderMeal, renderControledTextField, renderSelect
} from '../../utils/engageComponents'
import { sweetAlert } from '../../components/Alert/sweetAlert';
import RecurrenceModal from '../../components/RecurrenceModal/RecurrenceModal'

//Actions
import { getCommunityByIdAsync, GetCommunityMealTypes } from '../../actions/communityActions';
import { GetDiningLocations } from '../../actions/diningLocationActions';

import { Checkbox, Fab, Tab, Tabs, TextField } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';

import ClearIcon from '@material-ui/icons/Clear';
import { CheckBox, CheckBoxOutlineBlank, SearchRounded } from '@material-ui/icons';
import ImagesModal from '../../components/Images/ImagesModal';
import UpdateRecurrenceConfirmationModal from './UpdateRecurrenceConfirmationModal';



const validate = (values) => {
    const errors = {};

    const requiredField = 'required Field';
    //General Info
    if (values.GeneralInfo) {
        errors.GeneralInfo = {};

        if (!values.GeneralInfo.name) {
            errors.GeneralInfo.name = requiredField
        }

        if (values.GeneralInfo.name && values.GeneralInfo.name.length > 50) {
            errors.GeneralInfo.name = "Title must have less than 50 characters"
        }

        if (!values.GeneralInfo.description) {
            errors.GeneralInfo.description = requiredField
        }

        if (values.GeneralInfo.description && values.GeneralInfo.description.length > 100) {
            errors.GeneralInfo.description = "Description must have less than 100 characters"
        }

        if (!values.GeneralInfo.dateStart) {
            errors.GeneralInfo.dateStart = requiredField
        }

        if (!values.GeneralInfo.dateEndForRecurrence) {
            errors.GeneralInfo.dateEndForRecurrence = requiredField
        }

        if (!values.GeneralInfo.Periodicity || (values.GeneralInfo.Periodicity && values.GeneralInfo.Periodicity.name === '')) {
            errors.GeneralInfo.Periodicity = requiredField
        }

        if (!values.GeneralInfo.WeeklyPeriodicity) {
            errors.GeneralInfo.WeeklyPeriodicity = requiredField
        }

        if (!values.GeneralInfo.MultipleDatesPicker) {
            errors.GeneralInfo.MultipleDatesPicker = requiredField
        }

    } else {
        errors.GeneralInfo = {};
        errors.GeneralInfo.name = requiredField;
        errors.GeneralInfo.description = requiredField;
        errors.GeneralInfo.dateStart = requiredField;
        errors.GeneralInfo.dateEndForRecurrence = requiredField;
        errors.GeneralInfo.Periodicity = requiredField;
        errors.GeneralInfo.WeeklyPeriodicity = requiredField;
        errors.GeneralInfo.MultipleDatesPicker = requiredField;
    }

    return errors;
};

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};



export class AddEditDining extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: (props.data && props.data._id) ? this.props.data._id : undefined,
            action: (props.data && props.data._id) ? 'edit' : 'new',
            //Tabs
            //tabValue: 0,
            //textFielWithChips
            chipsArray: (props.data && props.data.tags) ? props.data.tags : [],
            chipTextFieldActualText: '',
            //General Info
            dateStart: props.data.dateStart ? props.data.dateStart : new Date(),
            dateEnd: props.data.dateEnd ? props.data.dateEnd : new Date(),
            diningType: undefined,
            selectedDiningPictureUrl: props.data.imageUrl ? props.data.imageUrl : undefined,
            selectedDiningTagText: '',
            diningPictureType: '',
            diningPictureName: '',
            diningPictureFile: '',
            diningUpdatePicture: false,
            selectedImageObj: undefined,
            translationTab: 0,
            titleEs: undefined,
            descriptionEs: undefined,
            titleFr: undefined,
            descriptionFr: undefined,
            openTranslationsModal: false,
            //CommunityId
            communityId: localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined,
            communityData: undefined,
            //End Recurrendy date
            endDateForRecurrency: props.data.recurrencyData && props.data.recurrencyData.endDateForRecurrency ? props.data.recurrencyData.endDateForRecurrency : undefined,
            //multi picker
            multuPickerAnchorEl: undefined,
            multiPickerItemsSelected: props.data.recurrencyData && props.data.recurrencyData.monthlyRecurrence ? props.data.recurrencyData.monthlyRecurrence : undefined,
            //weekDay
            weekDaysSelected: props.data.recurrencyData && props.data.recurrencyData.weeklyRecurrence ? props.data.recurrencyData.weeklyRecurrence : undefined,
            //Periodicity
            periodicityOptions: [{ name: 'Daily' }, { name: 'Weekly' }, { name: 'Monthly' }, { name: 'Custom' }],
            periodicityOptionSelected: props.data.recurrencyData && props.data.recurrencyData.recurrencyType ? props.data.recurrencyData.recurrencyType : undefined,
            openPeriodicityCombo: false,
            //RecurencyUpdate
            recurrenceUpdate: false,
            openModalRecurrenceUpdate: false,

            customDatesPickerAnchorEl: undefined,
            customDatesPickerSelected: undefined,
            openCustomDatePicker: false,

            RepeatValue: (props && props.data && props.data.recurrencyData && props.data.recurrencyData.customRepeatValue) ? { name: props.data.recurrencyData.customRepeatValue } : { name: 'Does not repeat' },
            RepeatValueOptions: [{ name: 'Does not repeat' }, { name: 'Daily' }, { name: 'Weekly' }, { name: 'Monthly' }, { name: 'Yearly' }],

            repeatInterval: (props && props.data && props.data.recurrencyData && props.data.recurrencyData.customRepeatInterval) ? props.data.recurrencyData.customRepeatInterval : '',
            repeatIntervalTouched: false,
            repeatIntervalError: 'field required',
            repeatValue: (props && props.data && props.data.recurrencyData && props.data.recurrencyData.customRepeatValue) ? props.data.recurrencyData.customRepeatValue : '',
            repeatValueTouched: false,
            repeatValueError: 'field required',
            repeatCustomMonthlySelection: (props && props.data && props.data.recurrencyData && props.data.recurrencyData.customRepeatMonthlySelection) ? props.data.recurrencyData.customRepeatMonthlySelection : '',
            repeatCustomMonthlySelectionTouched: false,
            repeatCustomMonthlySelectionError: 'field required',
            repeatOptions: [{ label: 'Day', value: 'daily' }, { label: 'Week', value: 'weekly' }, { label: 'Month', value: 'monthly' }],


            customSelectionText: (props && props.data && props.data.recurrencyData && props.data.recurrencyData.customRepeatValue) ? props.data.recurrencyData.customRepeatValue : '',

            titleMeal: (props && props.data && props.data.name) ? props.data.name : '',
            description: (props && props.data && props.data.description) ? props.data.description : '',
            locationsSelected: (props?.data?.diningLocations)?props.data.diningLocations.map(d=>({_id:d.locationId, name: d.name})):[],
            hideOnPrinting: (props && props.data && props.data.hideOnPrinting) ? props.data.hideOnPrinting : false,

            //Recurrence Modal
            recurrenceObj: { StartDate: props.data.dateStart ? props.data.dateStart : new Date() },
            recurrenceCleanInfo: (props && props.data && props.data.recurrencyData && props.data.recurrencyData.endDateForRecurrency) ? false : true,
            recurrenceInitialValue: (props && props.data && props.data.recurrencyData && props.data.recurrencyData.customRepeatValue) ? { name: props.data.recurrencyData.customRepeatValue } : { name: 'Does not repeat' },
            imageSearch: '',
            openSearchModal: false

        };

        if (props.data) {
            //GeneralInfo.Periodicity
            //GENERAL INFO
            this.props.dispatch(change('DiningForm', '_id', props.data._id ? props.data._id : ''));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.name', props.data.name ? props.data.name : ''));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.new', props.data.new ? props.data.new : ''));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.description', props.data.description ? props.data.description : ''));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.dateStart', props.data.dateStart ? props.data.dateStart : new Date()));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.dateEndForRecurrence', props.data.recurrencyData && props.data.recurrencyData.endDateForRecurrency ? props.data.recurrencyData.endDateForRecurrency : new Date()));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.imageUrl', props.data.imageUrl ? props.data.imageUrl : ''));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.Image', props.data.imageUrl ? props.data.imageUrl : ''));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.hideOnPrinting', props.data.hideOnPrinting ? props.data.hideOnPrinting : ''));

            this.props.dispatch(change('DiningForm', 'GeneralInfo.type', props.data.type ? props.data.type : ''));
            //
            //Tags
            this.props.dispatch(change('DiningForm', 'Tags.tags', ''));

            //Recurrence
            this.props.dispatch(change('DiningForm', 'GeneralInfo.Periodicity', (props.data.recurrencyData && props.data.recurrencyData.recurrencyType) ? props.data.recurrencyData.recurrencyType : ''));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.WeeklyPeriodicity', (props.data.recurrencyData && props.data.recurrencyData.weeklyRecurrence) ? props.data.recurrencyData.weeklyRecurrence : ''));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.MultipleDatesPicker', (props.data.recurrencyData && props.data.recurrencyData.monthlyRecurrence) ? props.data.recurrencyData.monthlyRecurrence.map((item) => item.ordinal) : ''));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.customSelectionText', (props.data.recurrencyData && props.data.recurrencyData.customSelectionText) ? props.data.recurrencyData.customSelectionText : ''));
        } else {
            this.props.dispatch(change('DiningForm', 'GeneralInfo.dateStart', new Date()));
            this.props.dispatch(change('DiningForm', 'GeneralInfo.dateEndForRecurrence', new Date()));
        }
    }

    async GetCommunityDataByCommunityId(communityId) {
        let communityData = undefined;

        if (communityId) {
            communityData = await this.props.getCommunityByIdAsync(communityId);

            if (communityData[0].timeZoneName) {

                const startDate = this.GetDateChangingTimeZone(this.state.dateStart, communityData[0].timeZoneName);
                const endDate = this.GetDateChangingTimeZone(this.state.dateEnd, communityData[0].timeZoneName);
                const endDateForRecurrency = this.GetDateChangingTimeZone(this.state.endDateForRecurrency, communityData[0].timeZoneName);

                this.setState({
                    communityData: communityData[0],
                    dateStart: startDate,
                    dateEnd: endDate,
                    endDateForRecurrency: endDateForRecurrency,
                })

            } else {
                this.setState({
                    communityData: communityData,
                })
            }
        }

        return communityData;
    };


    clearState() {
        this.setState({
            //textFielWithChips
            chipsArray: [],
            chipTextFieldActualText: '',
            //General Info
            startDate: this.GetUTCDate(new Date()),
            endDate: this.GetUTCDate(new Date()),
            //Dining Image
            selectedDiningImage: (this.props.data && this.props.data.imageUrl) ? this.props.data.imageUrl : undefined,
            objBase64selectedDiningImage: {},
            diningPictureType: '',
            diningPictureName: '',
            diningPictureFile: '',
            diningUpdatePicture: false
        });
    }

    componentDidMount() {

        if(this.props.data){
            document.title='Dinings - Edit Dining'

        }else{
            document.title='Dinings - Add Dining'
        }

        //Recurrency obj
        if (this.props && this.props.data && this.props.data.recurrencyData) {
            const recurrencyObjectToSetOnMount = this.GetRecurrencyObjectForRecurrencyModal(this.props.data.recurrencyData);
            this.setState({ recurrenceObj: recurrencyObjectToSetOnMount })
        }

        if (localStorage.getItem('communityId')) {

            this.GetCommunityDataByCommunityId(localStorage.getItem('communityId'));

            this.props.GetCommunityMealTypes(localStorage.getItem('communityId'));

            this.props.GetDiningLocations(localStorage.getItem('communityId'))
        }

        if (this.props.data && this.props.data.imageUrl && this.props.images) {

            const imgObj = this.props.images.find(i => i.imageUrl === this.props.data.imageUrl)
            this.setState({ selectedImageObj: imgObj })
        }

        if (this.props.data?.translations && this.props.data.translations.length > 0) {

            const spanishObj = this.props.data.translations.find(x => x.languageCode === 'es');

            const frenchObj = this.props.data.translations.find(x => x.languageCode === 'fr');

            if (spanishObj) {
                this.setState({ titleEs: spanishObj.name, descriptionEs: spanishObj.description });

                this.props.dispatch(change('DiningForm', 'GeneralInfo.titleEs', spanishObj.name));
                this.props.dispatch(change('DiningForm', 'GeneralInfo.descriptionEs', spanishObj.description));

            }

            if (frenchObj) {
                this.setState({ titleFr: frenchObj.name, descriptionFr: frenchObj.description });

                this.props.dispatch(change('DiningForm', 'GeneralInfo.titleFr', frenchObj.name));
                this.props.dispatch(change('DiningForm', 'GeneralInfo.descriptionFr', frenchObj.description));

            }

        }

        if(!this.props.data && (this.props.locationData && this.props.locationData.length>1)){
            this.setState({locationsSelected: [this.props.locationData[0]]})
        }


    };



    GetRecurrencyObjectForRecurrencyModal = (recurrencyData) => {
        try {

            if (!recurrencyData) return undefined;
            const newRecurrencyObj = {
                StartDate: this.state.dateStart ? this.state.dateStart : undefined,
                RepeatValue: (recurrencyData && recurrencyData.customRepeatValue && recurrencyData.customRepeatValue.length > 0) ? { name: recurrencyData.customRepeatValue } : undefined,
                RepeatInterval: (recurrencyData && recurrencyData.customRepeatInterval) ? recurrencyData.customRepeatInterval : 1,
                selectedWeekDays: (recurrencyData && recurrencyData.weeklyRecurrence && recurrencyData.weeklyRecurrence.length > 0) ? recurrencyData.weeklyRecurrence : [],
                MonthValue: (recurrencyData && recurrencyData.MonthValue) ? recurrencyData.MonthValue : { name: 'January', value: 0 },
                endDateForRecurrency: (recurrencyData && recurrencyData.endDateForRecurrency) ? recurrencyData.endDateForRecurrency : undefined,
                EndSelection: (recurrencyData && recurrencyData.customEndOption) ? recurrencyData.customEndOption : { name: 'After' },
                OccurrencesField: (recurrencyData && recurrencyData.customEndOcurrences) ? recurrencyData.customEndOcurrences : 1,
                customMonthlyDayNumber: (recurrencyData && recurrencyData.customMonthlyDayNumber) ? recurrencyData.customMonthlyDayNumber : undefined,
                customMonthlyOptionSelected: (recurrencyData && recurrencyData.customMonthlyOptionSelected) ? recurrencyData.customMonthlyOptionSelected : undefined,
                customSelectedMonthlyOrdinalPosition: (recurrencyData && recurrencyData.customSelectedMonthlyOrdinalPosition) ? recurrencyData.customSelectedMonthlyOrdinalPosition : undefined,
                customSelectedMonthlyRepetitionDay: (recurrencyData && recurrencyData.customSelectedMonthlyRepetitionDay) ? recurrencyData.customSelectedMonthlyRepetitionDay : undefined,
                OccurrenceLabel: (recurrencyData && recurrencyData.OccurrenceLabel) ? recurrencyData.OccurrenceLabel : ""
            }

            if (recurrencyData.customEndOption.name === 'Date') {
                newRecurrencyObj.EndSelection = { name: "On this date" }
            }

            return newRecurrencyObj;
        } catch (err) {
            return undefined;
        }


    }
    //#region Modal
    Modal = {
        paperModal: {
            backgroundColor: '#1f1f1f',
            padding: '6px',
            width: '45%',
            height: '75%',
            position: 'absolute',
            top: '20%',
            left: '35%'
        },
        stepperModal: {
            height: '10%',
        },
        contentModal: {
            height: '80%',
            width: '65%',
            padding: '20px'
        },
        buttonsModal: {
            height: '20%',
            justify: 'center',
        },
        hiddenButton: {
            display: 'none'
        },
        visibleButton: {
            marginBottom: '20px',
            textTransform: 'none'
        },
        visibleDisabledButton: {
            marginBottom: '20px',
            backgroundColor: '#ffffff',
            color: '#bdbdbd'
        }
    }
    //#endregion

    GetDateChangingTimeZone(date, timeZoneName) {

        let provisionalDate = new Date();

        if (date && timeZoneName) {
            if (date) {
                provisionalDate = new Date(new Date(date).toLocaleString("en-US", { timeZone: timeZoneName }));
            }
        }
        else {
            provisionalDate = date;
        }

        return provisionalDate;
    };

    GetUTCDate = (date, name = '') => {
        let isoDate = new Date();

        if (name !== '') {
            const first = name.split(' ')[0].toLowerCase();
            const second = name.split(' ')[1].toLowerCase();

            let provisionalDate = undefined;
            if (first === 'start') {
                provisionalDate = new Date(this.state.startDate)
            } else {
                provisionalDate = new Date(this.state.endDate)
            }

            if (date.toString().toLowerCase() !== 'invalid date' && (first === 'start' || first === 'end') && (second === 'date' || second === 'hour')) {
                let newDate = undefined;

                if (second === 'date') {

                    newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), provisionalDate.getHours(), provisionalDate.getMinutes());
                } else {

                    newDate = new Date(provisionalDate.getFullYear(), provisionalDate.getMonth(), provisionalDate.getDate(), date.getHours(), date.getMinutes());
                }

                isoDate = new Date(newDate).toISOString();
            } else {
                isoDate = provisionalDate.toISOString();
            }
        } else {
            isoDate = isoDate.toISOString();
        }
        return isoDate;
    };

    GetLocalTimeFromUTC = (isoDate) => {
        const localTime = new Date(isoDate);

        return localTime;
    };
    async onSubmitHandler(formData) {

        // if(!isFormValid())
        //     return

        let page = this.props.currentPage;

        /* Meal times*/
        let mealStart = new Date(this.state.diningType.timeStart)
        let mealEnd = new Date(this.state.diningType.timeEnd)
        let DiningDate = this.state.dateStart
        /* */

        let objToSend = {}
        objToSend._id = formData._id ? formData._id : undefined;
        objToSend.type = this.state.diningType.mealType;
        objToSend.mealTypeIconUrl = this.state.diningType.mealSolidIconUrl;
        objToSend.communityId = localStorage.getItem('communityId'); //this.state.communityId ? this.state.communityId : 'fca32fc3-6389-4333-bc89-f05564ef8611'; // TODO make it dinamyc
        objToSend.name = (formData.GeneralInfo && formData.GeneralInfo.name) ? formData.GeneralInfo.name : '';
        objToSend.description = (formData.GeneralInfo && formData.GeneralInfo.description) ? formData.GeneralInfo.description : '';
        objToSend.dateStart = new Date(DiningDate.getFullYear(), DiningDate.getMonth(), DiningDate.getDate(), mealStart.getHours(), mealStart.getMinutes(), 0, 0);
        objToSend.dateEnd = new Date(DiningDate.getFullYear(), DiningDate.getMonth(), DiningDate.getDate(), mealEnd.getHours(), mealEnd.getMinutes(), 0, 0);
        objToSend.tags = (this.state.chipsArray) ? this.state.chipsArray : [];
        objToSend.hideOnPrinting = this.state.hideOnPrinting;

        //Dining Image
        objToSend.imageUrl = this.state.selectedDiningPictureUrl;
        let objImage = {};

        const img = this.props.images.find(i => i.imageUrl === this.state.selectedDiningPictureUrl);

        if (!img && this.state.objBase64selectedDiningImage && this.state.objBase64selectedDiningImage.file && this.state.selectedDiningPictureUrl) {
            //Call Update Image to Server Await
            objImage = await this.props.AddDiningImage(this.state.objBase64selectedDiningImage, localStorage.getItem('communityId'))
            objToSend.imageUrl = objImage.url;
        }
        //objToSend.imageUrl = this.state.selectedDiningPictureUrl;

        const recurrencyObject = this.GetRecurrenceObject();

        if (recurrencyObject) {
            objToSend.recurrencyData = recurrencyObject;

            if (recurrencyObject.initialRecurrenceDate !== undefined) {
                objToSend.dateStart = new Date(objToSend.dateStart.setFullYear(recurrencyObject.initialRecurrenceDate.getFullYear(), recurrencyObject.initialRecurrenceDate.getMonth(), recurrencyObject.initialRecurrenceDate.getDate()));
                objToSend.dateEnd = new Date(objToSend.dateEnd.setFullYear(recurrencyObject.initialRecurrenceDate.getFullYear(), recurrencyObject.initialRecurrenceDate.getMonth(), recurrencyObject.initialRecurrenceDate.getDate()));
            }
        }

        //setting sDateTime
        //const sDateTime = new Date( objToSend.date.toLocaleString("en-US", {timeZone:'utc'}) )
        const sYear = objToSend.dateStart.getFullYear();
        const sMonth = ('0' + (objToSend.dateStart.getMonth() + 1)).slice(-2);
        const sDate = ('0' + objToSend.dateStart.getDate()).slice(-2);
        const sHour = ('0' + objToSend.dateStart.getHours()).slice(-2);
        const sMinute = ('0' + objToSend.dateStart.getMinutes()).slice(-2);
        const sDateTime = sYear + '-' + sMonth + '-' + sDate + 'T' + sHour + ':' + sMinute + ':00.000Z'

        objToSend.sDateTime = sDateTime;

        const eYear = objToSend.dateEnd.getFullYear();
        const eMonth = ('0' + (objToSend.dateEnd.getMonth() + 1)).slice(-2);
        const eDate = ('0' + objToSend.dateEnd.getDate()).slice(-2);
        const eHour = ('0' + objToSend.dateEnd.getHours()).slice(-2);
        const eMinute = ('0' + objToSend.dateEnd.getMinutes()).slice(-2);
        const eDateTime = eYear + '-' + eMonth + '-' + eDate + 'T' + eHour + ':' + eMinute + ':00.000Z'

        objToSend.eDateTime = eDateTime;

        objToSend.translations = []


        if (this.state.titleEs !== '' && this.state.descriptionEs !== '') {
            const spanishObj = {
                languageCode: 'es',
                name: this.state.titleEs,
                description: this.state.descriptionEs
            }

            objToSend.translations.push(spanishObj);
        }

        if (this.state.titleFr !== '' && this.state.descriptionFr !== '') {
            const frenchObj = {
                languageCode: 'fr',
                name: this.state.titleFr,
                description: this.state.descriptionFr
            }

            objToSend.translations.push(frenchObj);
        }

        objToSend.diningLocations = this.state.locationsSelected.filter(l => this.props.allLocations.some(nl => nl._id === l._id)).map(d=>({locationId:d._id, name:d.name}))

        setTimeout(() => {

            if (this.state._id && this.state._id.length > 0) {
                //is Upd

                if (this.state.recurrenceUpdate) {
                    objToSend.recurrenceUpdate = this.state.recurrenceUpdate;
                    objToSend.recurrencyId = (this.props.data && this.props.data.recurrencyId) ? this.props.data.recurrencyId : undefined;
                }

                this.props.UpdDining(this.state._id, objToSend, localStorage.getItem('communityId'));
            } else {
                //is Add
                if (this.props.activityData) {
                    let objToSort = { ...objToSend };
                    objToSort.isTheOne = true;

                    let addDiningData = this.props.activityData ? [...this.props.activityData] : []
                    addDiningData.push(objToSort);
                    addDiningData.sort((a, b) => {

                        if (new Date(a.date) > new Date(b.date)) {
                            return 1;
                        } else {
                            return -1;
                        }
                    });

                    const objIndexOnSorterdArray = addDiningData.findIndex(item => item.isTheOne === true);
                    const pageOfNewItem = Math.ceil(((objIndexOnSorterdArray > 0 ? objIndexOnSorterdArray : 0) + 1) / (this.props.itemPerPage ? this.props.itemPerPage : 5));

                    page = pageOfNewItem;
                }
                this.props.AddDining(objToSend, localStorage.getItem('communityId'));
                //page = this.props.newItemPage

            }
            this.clearState();
            this.props.closeDialog(page);
        }, 200);
    };

    GetRecurrencyObject = () => {
        let mealEnd = new Date(this.state.diningType.timeEnd)

        let recurrencyObject = undefined;

        //Recurrency Data
        const endDateForRecurrency = (this.state.endDateForRecurrency && this.state.dateStart && this.state.endDateForRecurrency > this.state.dateStart) ?
            new Date(
                this.state.endDateForRecurrency.getFullYear(),
                this.state.endDateForRecurrency.getMonth(),
                this.state.endDateForRecurrency.getDate(),
                mealEnd.getHours(),
                mealEnd.getMinutes(),
                0,
                0
            )
            : undefined;

        const recurrencyType = this.state.periodicityOptionSelected ? this.state.periodicityOptionSelected : undefined;
        const weeklyRecurrence = this.state.weekDaysSelected ? this.state.weekDaysSelected : undefined;
        const monthlyRecurrence = this.state.multiPickerItemsSelected ? this.state.multiPickerItemsSelected : undefined;

        const customRepeatInterval = this.state.repeatInterval ? this.state.repeatInterval : undefined;
        const customRepeatValue = this.state.repeatValue ? this.state.repeatValue : undefined;
        const customRepeatMonthlySelection = this.state.repeatCustomMonthlySelection ? this.state.repeatCustomMonthlySelection : undefined;
        const customSelectionText = this.state.customSelectionText ? this.state.customSelectionText : undefined;

        if (
            endDateForRecurrency &&
            recurrencyType &&
            (
                (recurrencyType.name.toLowerCase() === 'daily')
                ||
                (
                    recurrencyType.name.toLowerCase() === 'weekly' &&
                    weeklyRecurrence
                ) ||
                (
                    recurrencyType.name.toLowerCase() === 'monthly' &&
                    monthlyRecurrence
                ) ||
                (
                    recurrencyType.name.toLowerCase() === 'custom' &&
                    customRepeatInterval &&
                    customRepeatValue

                )
            )
        ) {

            const eYear = endDateForRecurrency.getFullYear();
            const eMonth = ('0' + (endDateForRecurrency.getMonth() + 1)).slice(-2);
            const eDate = ('0' + endDateForRecurrency.getDate()).slice(-2);
            const eHour = ('0' + endDateForRecurrency.getHours()).slice(-2);
            const eMinute = ('0' + endDateForRecurrency.getMinutes()).slice(-2);
            const eDateTime = eYear + '-' + eMonth + '-' + eDate + 'T' + eHour + ':' + eMinute + ':00.000Z'

            const newendDateForRecurrency = eDateTime;

            recurrencyObject = {
                endDateForRecurrency: newendDateForRecurrency,
                recurrencyType: recurrencyType,
                weeklyRecurrence: weeklyRecurrence,
                monthlyRecurrence: monthlyRecurrence,
                customRepeatInterval: customRepeatInterval,
                customRepeatValue: customRepeatValue,
                customRepeatMonthlySelection: customRepeatMonthlySelection,
                customSelectionText: customSelectionText,
            }
        }

        return recurrencyObject;
    }

    GetRecurrenceObject = () => {
        try {
            let recurrencyObject = undefined;

            const {
                EndSelection,
                MonthValue,
                RepeatInterval,
                OccurrencesField,
                RepeatValue,
                StartDate,
                selectedWeekDays,
                endDateForRecurrency,
                customMonthlyOptionSelected,
                customMonthlyDayNumber,
                customSelectedMonthlyOrdinalPosition,
                customSelectedMonthlyRepetitionDay,
                OccurrenceLabel,
                initialRecurrenceDate
            } = this.state.recurrenceObj;

            const newOccurrences = (OccurrencesField && OccurrencesField > 0) ? OccurrencesField : 1
            if (!RepeatValue || !RepeatInterval) {
                return undefined;
            }

            let repetitionLabel = 'days';

            switch (RepeatValue.name) {
                case 'Daily': repetitionLabel = 'days'; break;
                case 'Weekly': repetitionLabel = 'weeks'; break;
                case 'Monthly': repetitionLabel = 'months'; break;
                case 'Yearly': repetitionLabel = 'years'; break;
                default: repetitionLabel = 'days'; break;
            }

            let newEndData = undefined;
            if (StartDate && EndSelection && EndSelection.name === 'After') {
                newEndData = moment(StartDate);

                newEndData = newEndData.add(RepeatInterval * (newOccurrences - 1), repetitionLabel);
            } else if (StartDate && EndSelection && EndSelection.name === 'On this date' && endDateForRecurrency) {
                newEndData = endDateForRecurrency;
            }

            let endDate = (newEndData && this.state.dateStart && this.state.dateStart < newEndData) ? new Date(newEndData) : undefined;

            const recurrencyType = { name: 'Custom' };
            const weeklyRecurrence = selectedWeekDays ? selectedWeekDays : undefined;

            const customRepeatInterval = RepeatInterval ? RepeatInterval : undefined;
            const customRepeatValue = RepeatValue ? RepeatValue : undefined;

            if (
                endDate &&
                recurrencyType &&
                (

                    (
                        recurrencyType.name.toLowerCase() === 'custom' &&
                        customRepeatInterval &&
                        customRepeatValue

                    )
                )
            ) {
                recurrencyObject = {
                    endDateForRecurrency: endDateForRecurrency,
                    recurrencyType: recurrencyType,
                    weeklyRecurrence: weeklyRecurrence,
                    MonthValue: MonthValue,
                    customRepeatInterval: customRepeatInterval,
                    customRepeatValue: customRepeatValue.name,
                    customEndOption: EndSelection,
                    customEndOcurrences: newOccurrences,
                    customMonthlyOptionSelected: customMonthlyOptionSelected,
                    customMonthlyDayNumber: customMonthlyDayNumber ? customMonthlyDayNumber : undefined,
                    customSelectedMonthlyOrdinalPosition: customSelectedMonthlyOrdinalPosition,
                    customSelectedMonthlyRepetitionDay: customSelectedMonthlyRepetitionDay,
                    OccurrenceLabel: OccurrenceLabel,
                    initialRecurrenceDate: initialRecurrenceDate
                }
            }

            return recurrencyObject;
        } catch (err) {
        }
    }

    readImage(e) {
        //Base 64

        let reader = new FileReader();
        const imageSelected = e.target.files[0];

        if (imageSelected === undefined)
            return;

        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
            const objBase64 = {
                type: imageSelected.type,
                name: imageSelected.name.replace(/[:/#?&@%+~\s]/g, '_'),
                file: reader.result

            }
            this.setState({ selectedDiningPictureUrl: URL.createObjectURL(imageSelected), objBase64selectedDiningImage: objBase64, selectedImageObj: { name: '' } }, () => this.CheckValues());
        }
    };

    toDataURL = (url) => {
        var xhr = new XMLHttpRequest();

        xhr.onload = () => {
            var reader = new FileReader();

            reader.onloadend = () => {

                const imgName = `${this.state.imageSearch}_${moment(new Date()).format('YYYY_MM_DD_hh_mm_ss')}`

                const objBase64 = {
                    type: url.substring(url.lastIndexOf(".") + 1),
                    name: imgName.replace(/[:/#?&@%+~\s]/g, '_'),
                    file: reader.result
                }

                this.setState({ objBase64selectedDiningImage: objBase64 })

            }

            reader.readAsDataURL(xhr.response);
        };

        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();


    }

    // //#region  TABS    
    objStyles = {

        GridColum: {
            borderRadius: '16px',
            backgroundColor: '#1f1f1f',
            padding: ' 15px',
            paddingBottom: '35px',
            minHeight: '35px'
        },
        titleEngage: {
            color: '#686868',
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign: 'left'
        }
    }

    inputHidden = {
        display: 'none'
    }

    StyleDiningForm = {

        GridContent: {
            backgroundColor: '#1f1f1f',
            borderRadius: '4px',
        }
    }
    //#endregion

    //#region  RenderTextFieldWithChips
    handlerChipDelete = (chipText) => {
        let newChipArray = this.state.chipsArray;

        const index = newChipArray.indexOf(chipText);

        if (index !== -1) {
            newChipArray.splice(index, 1);
            this.setState({ chipsArray: newChipArray }, () => this.CheckValues())
        }

    };

    handlerAddChip = () => {

        const textNewChip = this.state.chipTextFieldActualText;
        const index = this.state.chipsArray.indexOf(textNewChip);
        let chips = this.state.chipsArray;

        if (chips.length < 10) {
            if (textNewChip.length <= 25) {
                if (index === -1 && textNewChip.length > 0) {
                    this.setState({ chipsArray: [...chips, textNewChip], chipTextFieldActualText: '' }, () => this.CheckValues())
                }
            } else {
                const message = 'The tag should contain less than 25 characters';
                sweetAlert('error', message, 'alert_AddEditDinning_MaxCharacters_Error');
                this.setState({ chipTextFieldActualText: '' })
            }
        } else {
            const message = 'Can´t add more than 10 tags per dining';
            sweetAlert('error', message, 'alert_AddEditDinning_MaxTags_Error');
        }

        this.props.dispatch(change('DiningForm', 'Tags.tags', ''));
    };
    //#endregion
    divImageClick = () => {
        //this.refs.fileUploader.click();
        document.getElementById("loadImage").click();
    }

    changeDiningPicture = (e) => {

        this.setState({
            selectedDiningPictureUrl: URL.createObjectURL(e.target.files[0]),
            diningPictureType: e.target.files[0].type,
            diningPictureName: e.target.files[0].name,
            // diningPictureFile: `data:image/png;base64,${e.target.files[0]}`
        })
        //  this.props.dispatch(change('CommunityForm','diningUpdated.picture.type', e.target.files[0].type));
        //  this.props.dispatch(change('CommunityForm','diningUpdated.picture.name', e.target.files[0].name));

        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
            this.setState({ diningPictureFile: reader.result });
            //    this.props.dispatch(change('CommunityForm','diningUpdated.picture.file', reader.result));
        }

        this.setState({ diningUpdatePicture: true });
    }

    handleSelectOptionChanged = (selectedOption) => {
        if (selectedOption.target.value) {
            this.setState({ diningType: selectedOption.target.value });
            this.props.dispatch(change('DiningForm', 'GeneralInfo.type', selectedOption.target.value ? selectedOption.target.value : 1));
        }
    };

    GetMealFromMealData = (mealType = 0, mealData = []) => {
        const meal = mealData.find((item) => item.mealType === mealType);

        return meal;
    }

    //#region HANDLERS
    openMultiPickerHandler = (element) => {
        this.setState({ multuPickerAnchorEl: element.currentTarget });
    };

    onMultiPickerChangeHandler = (newItem) => {


        const oldItemsSelected = this.state.multiPickerItemsSelected ? [...this.state.multiPickerItemsSelected] : [];
        let newItemsSelected = this.state.multiPickerItemsSelected ? [...this.state.multiPickerItemsSelected] : [];

        if (oldItemsSelected.find((item) => item.number === newItem.number)) {
            newItemsSelected = oldItemsSelected.filter((item) => item.number !== newItem.number);
        } else {
            newItemsSelected = [...oldItemsSelected, newItem].sort((a, b) => a.number > b.number);
        }

        this.setState({ multiPickerItemsSelected: newItemsSelected })
        this.props.dispatch(change('DiningForm', 'GeneralInfo.MultipleDatesPicker', newItemsSelected.map((item) => item.ordinal).join(',')));
    };

    periodocityComboChangeHandler = (e, newItem) => {
        if (!newItem)
            return

        if (newItem.name === '') {
            const dateStart = this.state.dateStart ? this.state.dateStart : new Date();

            this.setState({ endDateForRecurrency: dateStart });
        }

        this.setState({
            periodicityOptionSelected: newItem,
            multiPickerItemsSelected: undefined,
            weekDaysSelected: undefined,

            repeatInterval: '',
            repeatIntervalTouched: false,
            repeatValue: '',
            repeatValueTouched: false,
            repeatCustomMonthlySelection: '',
            repeatCustomMonthlySelectionTouched: false,
            customSelectionText: '',

        });

        this.props.dispatch(change('DiningForm', 'GeneralInfo.customSelectionText', ''));
        this.props.dispatch(change('DiningForm', 'GeneralInfo.Periodicity', newItem));
        this.props.dispatch(change('DiningForm', 'GeneralInfo.WeeklyPeriodicity', undefined));
        this.props.dispatch(change('DiningForm', 'GeneralInfo.MultipleDatesPicker', undefined));

        this.periodicityComboHandler(null, false);
    }

    periodicityComboHandler = (e, option) => {
        if (!option) {
            this.setState((prevState) => ({ openPeriodicityCombo: !prevState.openPeriodicityCombo }));
        } else {
            this.setState({ openPeriodicityCombo: option });
        }
    }

    periodicityComboOnBlurHandler = () => {
        setTimeout(() => {
            this.setState({ openPeriodicityCombo: false })
        }, 50);
    }

    weekDayOnChangeHandler = (itemSelected) => {

        const oldWeekDaysSelected = this.state.weekDaysSelected ? [...this.state.weekDaysSelected] : [];
        let newWeekDaysSelected = this.state.weekDaysSelected ? [...this.state.weekDaysSelected] : [];

        if (oldWeekDaysSelected.find((item) => item.number === itemSelected.number)) {
            newWeekDaysSelected = oldWeekDaysSelected.filter((item) => item.number !== itemSelected.number);
        } else {
            newWeekDaysSelected = [...oldWeekDaysSelected, itemSelected].sort((a, b) => a.number > b.number);
        }

        this.setState({ weekDaysSelected: newWeekDaysSelected });

        this.props.dispatch(
            change('DiningForm', 'GeneralInfo.WeeklyPeriodicity',
                (newWeekDaysSelected && Array.isArray(newWeekDaysSelected) && newWeekDaysSelected.length > 0) ? newWeekDaysSelected : undefined));
    }

    SetMealDate = (date, dateType) => {
        const oldStartDate = this.state.dateStart ? this.state.dateStart : new Date();
        const oldEndDate = this.state.endDateForRecurrency ? this.state.endDateForRecurrency : new Date();


        const communityTimeZone = (this.state.communityData && this.state.communityData.timeZoneName) ? this.state.communityData.timeZoneName : undefined;
        const newDate = this.GetDateChangingTimeZone(date, communityTimeZone);

        if (dateType === 'start') {
            if (newDate >= oldEndDate) {
                this.setState({
                    periodicityOptionSelected: undefined,
                    weekDaysSelected: undefined,
                    multiPickerItemsSelected: undefined,

                    repeatInterval: '',
                    repeatIntervalTouched: false,
                    repeatValue: '',
                    repeatValueTouched: false,
                    repeatCustomMonthlySelection: '',
                    repeatCustomMonthlySelectionTouched: false,
                    customSelectionText: '',
                })

                this.props.dispatch(change('DiningForm', 'GeneralInfo.customSelectionText', ''));
                this.props.dispatch(change('DiningForm', 'GeneralInfo.WeeklyPeriodicity', undefined));
                this.props.dispatch(change('DiningForm', 'GeneralInfo.MultipleDatesPicker', undefined));
            }
        } else if (dateType === 'end') {
            if (oldStartDate >= newDate) {
                this.setState({
                    periodicityOptionSelected: undefined,
                    weekDaysSelected: undefined,
                    multiPickerItemsSelected: undefined,

                    repeatInterval: '',
                    repeatIntervalTouched: false,
                    repeatValue: '',
                    repeatValueTouched: false,
                    repeatCustomMonthlySelection: '',
                    repeatCustomMonthlySelectionTouched: false,
                    customSelectionText: '',
                })


                this.props.dispatch(change('DiningForm', 'GeneralInfo.customSelectionText', ''));
                this.props.dispatch(change('DiningForm', 'GeneralInfo.WeeklyPeriodicity', undefined));
                this.props.dispatch(change('DiningForm', 'GeneralInfo.MultipleDatesPicker', undefined));

            }
        }

        switch (dateType) {
            case 'start':
                if (oldEndDate >= newDate) {
                    this.setState({
                        dateStart: newDate,

                        repeatInterval: '',
                        repeatIntervalTouched: false,
                        repeatValue: '',
                        repeatValueTouched: false,
                        repeatCustomMonthlySelection: '',
                        repeatCustomMonthlySelectionTouched: false,
                        customSelectionText: '',
                    }, () => this.CheckValues())
                    this.props.dispatch(change('DiningForm', 'GeneralInfo.customSelectionText', ''));
                    this.props.dispatch(change('DiningForm', 'GeneralInfo.dateStart', newDate ? newDate : ''));
                } else {
                    this.setState({
                        dateStart: newDate,
                        endDateForRecurrency: newDate,

                        repeatInterval: '',
                        repeatIntervalTouched: false,
                        repeatValue: '',
                        repeatValueTouched: false,
                        repeatCustomMonthlySelection: '',
                        repeatCustomMonthlySelectionTouched: false,
                        customSelectionText: '',
                    }, () => this.CheckValues())
                    this.props.dispatch(change('DiningForm', 'GeneralInfo.customSelectionText', ''));
                    this.props.dispatch(change('DiningForm', 'GeneralInfo.dateStart', newDate ? newDate : ''));
                    this.props.dispatch(change('DiningForm', 'GeneralInfo.dateEndForRecurrence', newDate ? newDate : ''));

                }
                break;
            case 'end':
                this.setState({
                    endDateForRecurrency: newDate,

                    repeatInterval: '',
                    repeatIntervalTouched: false,
                    repeatValue: '',
                    repeatValueTouched: false,
                    repeatCustomMonthlySelection: '',
                    repeatCustomMonthlySelectionTouched: false,
                    customSelectionText: '',
                }, () => this.CheckValues())
                this.props.dispatch(change('DiningForm', 'GeneralInfo.customSelectionText', ''));
                this.props.dispatch(change('DiningForm', 'GeneralInfo.dateEndForRecurrence', newDate ? newDate : ''));
                break;
            default:
                break;
        }

        if (dateType === 'start') {
            this.setState({ recurrenceObj: { StartDate: newDate } }, () => this.CheckValues())
        }
    }
    //#endregion

    clickButtonSave = (e, item, c) => {
        setTimeout(() => {

            var link = document.getElementById('save_btn2')
            if (link)
                link.click()

            this.setState({ openModalRecurrenceUpdate: false });
        }, 200);
    };

    checkIfHaveRecurrence = () => {
        if (this.props.data && this.props.data.recurrencyData && this.props.data.recurrencyData.endDateForRecurrency) {
            this.setState({ openModalRecurrenceUpdate: true });
        } else {
            this.clickButtonSave();
        }

    }


    OpenUploadImage = () => {
        var link = document.getElementsByClassName('divContentImageLoader');
        link[0].click();
    }

    openCustomDatePickerHandler = (e, newState = undefined) => {

        if (newState && newState.toLowerCase() === 'close') {
            this.setState({ openCustomDatePicker: false })

            if (!this.state.customSelectionText || this.state.customSelectionText === '') {
                this.setState({
                    weekDaysSelected: undefined,
                    repeatInterval: '',
                    repeatIntervalTouched: false,
                    repeatValue: '',
                    repeatValueTouched: false,
                    repeatCustomMonthlySelection: '',
                    repeatCustomMonthlySelectionTouched: false,
                    customSelectionText: '',
                    titleEs: '',
                    descriptionEs: '',
                    titleFr: '',
                    descriptionFr: '',
                })
            }

        } else {

            this.setState((prevState) => ({ openCustomDatePicker: !prevState.openCustomDatePicker }));
        }

        //this.setState({ customDatesPickerAnchorEl: element.currentTarget});
    };

    onChangeRepeatIntervalHandler = (event) => {
        try {
            const value = (event && event.target && event.target.value) ? event.target.value : '';
            let newValue = '';

            const regex = new RegExp('^\\d+$');

            if (value && value.length > 0) {
                if (regex.test(value)) {
                    newValue = value;
                } else {

                    newValue = this.state.repeatInterval;
                }
            } else { }

            const singular = [{ label: 'Day', value: 'daily' }, { label: 'Week', value: 'weekly' }, { label: 'Month', value: 'monthly' }];
            const plural = [{ label: 'Days', value: 'daily' }, { label: 'Weeks', value: 'weekly' }, { label: 'Months', value: 'monthly' }];

            let repeatOptions = [];

            if (newValue && newValue > 1) {
                repeatOptions = plural;
            } else {
                repeatOptions = singular;
            }

            this.setState({ repeatInterval: newValue, repeatOptions: repeatOptions })

        } catch (err) { }
    }

    onRepeatValueChangeHandler = (event) => {
        try {
            const newValue = (event && event.target && event.target.value) ? event.target.value : '';

            this.setState({ repeatValue: newValue });
        } catch (err) { }
    }

    onCustomSelectedDaysChangeHandler = (selectedDays) => {
        try {
            this.state({ customPickerSelectedWeekDays: selectedDays })
        } catch (err) { }
    }

    onCustomPickerWeeklySelectionChangeChandler = (itemSelected) => {
        try {

            const oldWeekDaysSelected = this.state.weekDaysSelected ? [...this.state.weekDaysSelected] : [];
            let newWeekDaysSelected = this.state.weekDaysSelected ? [...this.state.weekDaysSelected] : [];

            if (oldWeekDaysSelected.find((item) => item.number === itemSelected.number)) {
                newWeekDaysSelected = oldWeekDaysSelected.filter((item) => item.number !== itemSelected.number);
            } else {
                newWeekDaysSelected = [...oldWeekDaysSelected, itemSelected].sort((a, b) => a.number > b.number);
            }

            this.setState({ weekDaysSelected: newWeekDaysSelected });

            this.props.dispatch(
                change('DiningForm', 'GeneralInfo.WeeklyPeriodicity',
                    (newWeekDaysSelected && Array.isArray(newWeekDaysSelected) && newWeekDaysSelected.length > 0) ? newWeekDaysSelected : undefined));

        } catch (err) { }
    }

    onCustomMonthlyRepeatChangeHandler = (selection) => {
        try {
            this.setState({ repeatCustomMonthlySelection: selection })
        } catch (err) { }
    }

    onTitleChange = (e) => {
        try {
            const newTitle = (e && e.target && e.target.value) ? e.target.value : '';

            if (!newTitle) {
                this.setState({ 'titleMeal': '' });
            } else if (newTitle && newTitle.length <= 50) {
                this.setState({ 'titleMeal': newTitle });
            }
        } catch (err) { }
    }

    onDescriptionChange = (e) => {
        try {
            const newDesc = (e && e.target && e.target.value) ? e.target.value : '';

            if (!newDesc) {
                this.setState({ 'description': '' });
            } else if (newDesc && newDesc.length <= 100) {
                this.setState({ 'description': newDesc });
            }

        } catch (err) { }
    }

    EndAdornment = ({ recurrencySelection }) => {
        let showClearIcon = false;
        if (this.state.periodicityOptionSelected.name.toLowerCase() === 'monthly') {
            if (
                this.state.multiPickerItemsSelected &&
                this.state.multiPickerItemsSelected
            ) {
                showClearIcon = true;
            }
        } else if (this.state.periodicityOptionSelected.name.toLowerCase() === 'custom') {
            if (
                this.state.repeatInterval &&
                this.state.repeatValue &&
                this.state.customSelectionText
            ) {
                showClearIcon = true;
            }
        }


        return (
            <InputAdornment position="end">
                {
                    (showClearIcon) ?
                        <IconButton onClick={(e) => this.CleanRecurrencySelection(e, recurrencySelection)} color="white">
                            <ClearIcon style={{ color: 'white' }} fontSize="small" />
                        </IconButton>
                        :
                        ""
                }
            </InputAdornment>
        );
    }

    //Methods
    CleanRecurrencySelection = (e, recurrencySelection) => {
        e.stopPropagation();

        switch (recurrencySelection.toLowerCase()) {
            case 'monthly':
                this.setState({
                    multiPickerItemsSelected: undefined
                })
                this.props.dispatch(change('DiningForm', 'GeneralInfo.MultipleDatesPicker', ''));

                break;
            case 'custom':
                this.setState({
                    customSelectionText: undefined,
                    weekDaysSelected: undefined,
                    repeatInterval: '',
                    repeatIntervalTouched: false,
                    repeatValue: '',
                    repeatValueTouched: false,
                    repeatCustomMonthlySelection: '',
                    repeatCustomMonthlySelectionTouched: false,
                });
                this.props.dispatch(change('DiningForm', 'GeneralInfo.customSelectionText', ''));

                break;
            default:
                break;

        }


    }



    handleChangeTab = (event, newValue) => {
        this.setState({ translationTab: newValue });
    };

    a11yProps = (index) => {
        return {
            id: `full-width-dining-tab-${index}`,
            'aria-controls': `full-width-dining-tabpanel-${index}`,
        };
    };

    handleChangeTranslationIndex = (index) => {
        this.setState({ translationTab: index })
    }

    OnTranslationChange = (newItem, languageCode = undefined, fieldName = undefined) => {
        try {

            if (!languageCode || !fieldName) return undefined;

            if (languageCode === 'es') {

                switch (fieldName) {
                    case 'title':

                        if (newItem && newItem.length > 20) {
                            this.setState((prevState) => ({ titleEs: prevState.titleEs }))
                            this.props.dispatch(change('DiningForm', 'GeneralInfo.titleEs', this.state.titleEs));
                        } else {
                            this.setState({ titleEs: newItem })
                            this.props.dispatch(change('DiningForm', 'GeneralInfo.titleEs', ''));
                        }

                        break;
                    case 'description':

                        this.setState({ descriptionEs: newItem })
                        this.props.dispatch(change('DiningForm', 'GeneralInfo.descriptionEs', ''));

                        break;
                    default:
                        break;
                }
            }

            if (languageCode === 'fr') {
                switch (fieldName) {
                    case 'title':

                        if (newItem && newItem.length > 20) {
                            this.setState((prevState) => ({ titleFr: prevState.titleFr }))
                            this.props.dispatch(change('DiningForm', 'GeneralInfo.titleFr', this.state.titleFr));
                        } else {
                            this.setState({ titleFr: newItem })
                            this.props.dispatch(change('DiningForm', 'GeneralInfo.titleFr', ''));
                        }

                        break;
                    case 'description':

                        this.setState({ descriptionFr: newItem })
                        this.props.dispatch(change('DiningForm', 'GeneralInfo.descriptionFr', ''));
                        break;
                    default:
                        break;
                }
            }

        } catch (err) { }
    }

    openRecurrenceModal = () => {
        this.setState({ openRecurrenceModal: true })
    }

    onSaveRecurrenceFormHandler = (recurrenceObj) => {
        this.setState({ openRecurrenceModal: false, recurrenceUpdate: true, recurrenceCleanInfo: false, recurrenceInitialValue: { name: recurrenceObj.customRepeatValue }, recurrenceObj: recurrenceObj }, () => { (this.props.isSaveDisabled) && this.props.enableBtn(); });
    }

    onCloseRecurrenceModal = () => {
        if (this.state.recurrenceCleanInfo)
            this.setState({ openRecurrenceModal: false, RepeatValue: { name: 'Does not repeat' } });
        else
            this.setState({ openRecurrenceModal: false, RepeatValue: this.state.recurrenceInitialValue });
    }

    OnRepeatValueChangeHandler = (e, newItem) => {
        try {
            if (newItem.name !== 'Does not repeat')
                this.setState({ RepeatValue: newItem, openRecurrenceModal: true });
            else
                this.setState({ RepeatValue: newItem, openRecurrenceModal: false });
        } catch (err) { }
    }

    handleRepeatValueOnClose = (e) => {
        try {
            if (e.type === 'click' && !this.state.openRecurrenceModal && this.state.RepeatValue !== 'Does not repeat') {
                this.setState({ openRecurrenceModal: true });
            }

        } catch (err) { }
    }


    CheckValues = () => {

        if (this.props.data) {

            const { translations, name, new: newSwitch, description, dateStart, imageUrl, hideOnPrinting, type, tags, diningLocations } = this.props.data;

            const communityTimeZone = (this.state.communityData && this.state.communityData.timeZoneName) ? this.state.communityData.timeZoneName : undefined;
            const timeZoneDate = this.GetDateChangingTimeZone(dateStart, communityTimeZone);

            const spanishObj = translations?.find(x => x.languageCode === 'es');
            const frenchObj = translations?.find(x => x.languageCode === 'fr');

            //Check for every field that could have changed
            if ((this.state.titleMeal && this.state.titleMeal !== '' && this.state.titleMeal !== name)
                || (this.state.description && this.state.description !== '' && this.state.description !== description)
                || (this.state.newState && this.state.newState !== newSwitch)
                || (this.state.dateStart && new Date(this.state.dateStart).getTime() !== new Date(timeZoneDate).getTime())
                || (this.state.selectedDiningPictureUrl !== imageUrl)
                || (this.state.hideOnPrinting !== hideOnPrinting)
                || (this.state.diningType && this.state.diningType?.mealType !== type)
                || (this.state.locationsSelected && JSON.stringify(this.state.locationsSelected) !== JSON.stringify(diningLocations.map(d=>({_id:d.locationId, name:d.name}))))
                || (this.state.chipsArray && JSON.stringify(this.state.chipsArray) !== JSON.stringify(tags))
                || (spanishObj?.titleEs !== this.state.titleEs)
                || (spanishObj?.descriptionEs !== this.state.descriptionEs)
                || (frenchObj?.titleFr !== this.state.titleFr)
                || (frenchObj?.descriptionFr !== this.state.descriptionFr)
            ) {
                (this.props.isSaveDisabled) && this.props.enableBtn();
            } else {
                (!this.props.isSaveDisabled) && this.props.disableBtn();
            }

        }

    }


    handleSearch = () => {
        const search = this.state.imageSearch;

        if (search && search !== '' && search.length <= 100) {

            this.props.GetPixabyImages(search, 1);
            this.setState({ openSearchModal: true });
        }
    }

    handleSelectImage = (image) => {
        this.setState({ selectedDiningPictureUrl: image, openSearchModal: false }, () => this.CheckValues());
        this.toDataURL(image);
        this.props.ClearImages();
    }
    handleChangeSearch = (newSearch) => {
        this.setState({ imageSearch: newSearch })
    }
    handleResetSearch = () => {
        this.setState({ selectedDiningPictureUrl: '', imageSearch: '' })
    }

    handleCancelImage = () => {
        this.setState({ openSearchModal: false })
        this.props.ClearImages();
    }

    handleSelectLocation=(location)=>{
        const arr = this.state.locationsSelected;

        const item = arr.find(item =>item._id===location._id);

        if (!item) {
            arr.push(location)
        }
        else {
            const indexToDelete = arr.findIndex(object =>(object._id === location._id));
            arr.splice(indexToDelete, 1);

        }

        this.setState({ locationsSelected: arr }, ()=>this.CheckValues());
    }


    render() {
        if (!this.state.diningType) {

            const mealType = (this.props.data && this.props.data.type) ? this.props.data.type : 1;
            const mealData = (this.props.mealsData) ? this.props.mealsData : [];
            const meal = this.GetMealFromMealData(mealType, mealData);

            if (meal) {
                this.setState({ diningType: meal });
            }
        }

        return (
            <div >
                <form >
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="imgalignrigth-engage appbtn-details-engage">
                                <div id="save_btn" className="appbtn-engage skybluebtn-engage" onClick={() => this.checkIfHaveRecurrence()}>
                                    Recurrency update
                                </div>
                                <div id="save_btn2" className="appbtn-engage skybluebtn-engage" onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Save
                                </div>
                                <div id="cancel_btn" className="appbtn-engage redbtn-engage" onClick={this.props.closeDialog}>
                                    Cancel
                                </div>
                            </div>
                        </Grid>
                    </Grid>


                    <Fab
                        id="dining-translation-button"
                        color='primary'
                        onClick={() => this.setState({ openTranslationsModal: true })}
                        classes={{
                            root: 'fab',
                            primary: "fabColor"
                        }}
                        size="large"
                    >
                        <FontAwesomeIcon
                            icon={faLanguage}
                            color='white'
                            size='2x'
                        />
                    </Fab>

                    <Grid container>
                        <Grid container justify='space-around'   >
                            <Grid item xs={12} sm={12} md={4} >
                                <Grid container direction='column'>
                                    <Grid item xs={12} className='setUpTitleEngage' >
                                        General Info
                                    </Grid>
                                    <Grid item xs={11} >
                                        <Grid container direction='colum' style={{ ...this.objStyles.GridColum, }}>
                                            <Grid item xs={12} style={{ padding: '10px', }}>
                                                <Field
                                                    id='add_dining_title'
                                                    name="GeneralInfo.name"
                                                    label="Title"
                                                    maxLength={50}
                                                    component={renderControledTextField}
                                                    valueToSet={(this.state && this.state.titleMeal) ? this.state.titleMeal : undefined}
                                                    onChange={this.onTitleChange}
                                                    onBlur={() => this.CheckValues()}
                                                />
                                                <Grid item container alignContent='center' justifyContent='flex-end' style={{ paddingRight: '15px' }}>
                                                    {
                                                        (this.state?.titleMeal && this.state.titleMeal.length > 0) ?
                                                            <Grid item className='characterCount'> {`${this.state.titleMeal.length}/50`}</Grid>
                                                            :
                                                            undefined
                                                    }
                                                </Grid>
                                                {
                                                    (this.state.titleMeal && this.state.titleMeal.length > 25) ?
                                                        <Grid>
                                                            <Grid className='errorText'>Title may be abbreviated to 25 characters for printing: </Grid>
                                                            <Grid item className="characterCount">{`${this.state.titleMeal.substring(0, 25)}...`}</Grid>
                                                        </Grid>

                                                        :
                                                        undefined
                                                }
                                            </Grid>
                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                <Field
                                                    name="GeneralInfo.description"
                                                    label="Description"
                                                    rows={4}
                                                    maxLength={100}
                                                    component={renderTextField}
                                                    onChange={this.onDescriptionChange}
                                                    onBlur={() => this.CheckValues()}
                                                    id='add_dining_description'
                                                />
                                                <Grid item container alignContent='center' justifyContent='flex-end' style={{ paddingRight: '15px' }}>
                                                    {
                                                        (this.state?.description && this.state.description.length > 0) ?
                                                            <Grid item className="characterCount"> {`${this.state.description.length}/100`}</Grid>
                                                            :
                                                            undefined
                                                    }
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} style={{ padding: '10px', paddingTop: '30px' }}>
                                                <Grid container direction='column' justify='center' alignItems='center'>
                                                    <TextField
                                                        name='image_url'
                                                        type='text'
                                                        label='Image'
                                                        placeholder='Image Search'
                                                        fullWidth
                                                        value={this.state.imageSearch}
                                                        onChange={(e) => { this.setState({ imageSearch: e.target.value }) }}
                                                        onKeyDown={e => { if (e && e.keyCode && e.keyCode === 13) { this.handleSearch() } }}
                                                        style={{ paddingRight: '15px' }}
                                                        InputProps={{
                                                            endAdornment:
                                                                <InputAdornment position='end'>
                                                                    <IconButton id='dining_delete_icon' onClick={this.handleResetSearch} className="icon_btn"><ClearIcon style={{ color: 'white', opacity: '0.56' }} /></IconButton>
                                                                    <IconButton id='dining_search_icon' onClick={this.handleSearch} className="icon_btn"><SearchRounded style={{ color: 'white', fontSize: 30 }} /></IconButton>
                                                                </InputAdornment>

                                                        }}
                                                        error={this.state.imageSearch.length > 100}
                                                        helperText={this.state.imageSearch.length > 100 && 'The search must contain less than 100 characters'}
                                                    />
                                                    <Grid item container alignContent='center' justifyContent='flex-end' style={{ paddingRight: '15px' }}>
                                                        {
                                                            (this.state?.imageSearch && this.state.imageSearch.length > 0) ?
                                                                <Grid item className="characterCount"> {`${this.state.imageSearch.length}/100`}</Grid>
                                                                :
                                                                undefined
                                                        }
                                                    </Grid>
                                                    <Grid className='helperText' style={{ margin: '1rem 0rem' }}>Type in your image search keyword(s) and click the search icon or press Enter</Grid>

                                                    <RenderImageLoaderMeal
                                                        text=''
                                                        imageUrl={this.state.selectedDiningPictureUrl}
                                                        imageName='Dining Image'
                                                        onChange={(e) => this.readImage(e, 'selectedDiningPictureUrl')}
                                                        idToSet='add_dining_image'
                                                    />

                                                    <Grid item container xs={12} justify='center'>
                                                        <Grid style={{ borderBottom: '1px solid white', cursor: 'pointer', paddingTop: '25px' }} onClick={this.OpenUploadImage}>
                                                            <img
                                                                src='https://engage360.s3.amazonaws.com/Icons/Categories/upload.svg'
                                                                alt='upload'
                                                                height={'20px'}
                                                                width={'20px'}
                                                            />
                                                            <span style={{ color: 'white', fontFamily: 'Gotham-Book', fontSize: '16px', marginLeft: '10px' }}>
                                                                Upload Custom
                                                            </span>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} >
                                <Grid container direction='column'>
                                    <Grid item xs={12} className='setUpTitleEngage' >
                                        Identifiers
                                    </Grid>
                                    <Grid item xs={11}>
                                        <Grid container direction='column'>
                                            <Grid item xs={12}>
                                                <Grid container direction='colum' style={this.objStyles.GridColum}>
                                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                                        <Field
                                                            name="Tags.tags"
                                                            label="Tags"
                                                            maxLength={20}
                                                            value={this.state.chipTextFieldActualText}
                                                            chipsOptions={this.state.chipsArray}
                                                            handlerOnChipDelete={(chipText) => this.handlerChipDelete(chipText)}
                                                            handlerOnClickAddButton={() => this.handlerAddChip()}
                                                            onChange={(e) => this.setState({ chipTextFieldActualText: e.target.value })}
                                                            onKeyDown={e => { if (e && e.keyCode && e.keyCode === 13) { this.handlerAddChip(); } }}
                                                            component={renderTextFieldWithChips}
                                                            id='add_dining_tags'
                                                        />
                                                        <Grid className='helperText'>Press Enter after each desired tag description.</Grid>
                                                    </Grid>
                                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                                        <Grid item xs={12} className='setUpTitleEngage'>
                                                            Meal Category
                                                        </Grid>
                                                        <Grid item container direction='row' xs={12}>
                                                            {
                                                                this.props.mealsData && this.props.mealsData.map((item, index) => {
                                                                    return (
                                                                        <Grid item container direction='column' alignItems='center' justify='center'
                                                                            className={this.state.diningType && this.state.diningType._id === item._id ? "iconMealTypeCard iconMealTypeCardSelected" : "iconMealTypeCard"}
                                                                            xs={4}
                                                                            onClick={
                                                                                () => {
                                                                                    this.setState({ diningType: item }, () => this.CheckValues());
                                                                                    this.props.dispatch(change('DiningForm', 'GeneralInfo.type', item ? item : ""));
                                                                                }
                                                                            }
                                                                            id={`icon_${item._id}`}
                                                                        >
                                                                            <img
                                                                                item
                                                                                src={item.mealIconUrl}
                                                                                alt='icon'
                                                                                className="ListIcon"
                                                                            />
                                                                            <Grid item className="iconMealTypeCardName">{item.mealName}</Grid>
                                                                        </Grid>
                                                                    )
                                                                })
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    {/* Dining Locations */}
                                                    {
                                                        this.props.locationData && this.props.locationData.length>0?
                                                        <Grid item container xs={12}>
                                                            <Grid item xs={12} className='setUpTitleEngage'>Dining Location</Grid>
                                                            <Grid item xs={12} className='helperText' style={{marginBottom:'1rem'}}>Select each dining location where this menu item will be served.</Grid>
                                                            
                                                            <Grid item container xs={12} alignItems='stretch' justifyContent='flex-start'>
                                                                {   

                                                                    this.props.locationData.map((l, index)=>{
                                                                        const isSelected = this.state.locationsSelected.find(i=>i._id===l._id)

                                                                        return(
                                                                            <Grid item container key={l._id} id={`location_${l._id}`} className="category_box_wrapper"
                                                                                style={{marginRight:((index+1)%3===0)?'0%':'2%', color:'white'}}
                                                                            >
                                                                                <Grid item container justifyContent='center' 
                                                                                    className={isSelected?'filters_category_box_selected':'filters_category_box'}
                                                                                    onClick={()=>this.handleSelectLocation(l)}
                                                                                >
                                                                                    <Grid item container xs={12} justifyContent='flex-end'>
                                                                                        <Checkbox
                                                                                            checked={isSelected?true:false}
                                                                                            onChange={(e) => this.handleSelectLocation(l) }
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                            icon={<CheckBoxOutlineBlank />}
                                                                                            checkedIcon={<CheckBox style={{color:'white'}}/>}
                                                                                            id={`location_checkbox_${l._id}`}
                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid item container xs={12} justifyContent='center'>
                                                                                    {
                                                                                        <span style={{fontFamily:'Gotham-Book', fontSize:'60px'}}>
                                                                                            {l.name && l.name.length>0? l.name.charAt(0).toUpperCase():''}
                                                                                        </span>
                                                                                    }
                                                                                    </Grid>
                                                                            
                                                                                    <Grid className="MuiInputBase-root" style={{color:'white', textAlign:'center'}}>{l.name}</Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        )
                                                                    })

                                                                }

                                                            </Grid>

                                                        </Grid>
                                                        :
                                                        <></>
                                                    }

                                                    {/* Hide on print */}
                                                    <Grid item container alignContent='center' justify='flex-start'>
                                                        <Grid item xs={12} style={{ padding: '10px' }}>
                                                            <Field
                                                                name="GeneralInfo.hideOnPrinting"
                                                                label="Hide on print"
                                                                checked={this.state.hideOnPrinting}
                                                                onClick={() => this.setState((prevState) => ({ hideOnPrinting: !prevState.hideOnPrinting }), () => this.CheckValues())}
                                                                component={renderActivitySwitch}
                                                                idToSet='dining_hideOnPrinting_switch'
                                                                id='dining_hideOnPrinting_switch'
                                                                stylesLabel={{ fontSize: '24px', fontFamily: 'Gotham-Book', color: '#F0EFEF', textAlign: 'left' }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3}>
                                <Grid container direction='column'>
                                    <Grid item xs={12} className='setUpTitleEngage' >
                                        Recurrences
                                    </Grid>
                                    <Grid item xs={11}>
                                        <Grid container direction='column'>
                                            <Grid item xs={12}>
                                                <Grid container direction='colum' style={this.objStyles.GridColum}>
                                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                                        <Field
                                                            name="GeneralInfo.dateStart"
                                                            labelDate="Start Date"
                                                            selectedDate={this.state.dateStart} //most be an date object is use in both date and time
                                                            onDateChange={(date) => this.SetMealDate(date, 'start')}
                                                            maxLength={20}
                                                            component={renderSingleDatePicker}
                                                            idToSet='add_dining_start_date'
                                                            id='add_dining_start_date'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                                        <Field
                                                            showStartAdornment={true}
                                                            name="RepeatValue"
                                                            label="Repeats"
                                                            maxLength={20}
                                                            selected={this.state.RepeatValue ? this.state.RepeatValue : { name: 'Does not repeat' }}
                                                            optionsItemsIconsData={this.state.RepeatValueOptions ? this.state.RepeatValueOptions : [{ name: 'Does not repeat' }]}
                                                            onChangeHandler={(e, newItem) => this.OnRepeatValueChangeHandler(e, newItem)}
                                                            onCloseHandler={(e) => this.handleRepeatValueOnClose(e)}
                                                            component={renderSelect}
                                                            diableClear={true}
                                                            idToSet="RepeatValue"
                                                            id='RepeatValue'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} className="OcurrenceLabel">
                                                        {this.state.recurrenceObj?.OccurrenceLabel ? this.state.recurrenceObj.OccurrenceLabel : ''}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Confirm update modal */}
                    <Modal
                        open={this.state.openModalRecurrenceUpdate}
                        onClose={() => this.setState({ openModalRecurrenceUpdate: false })}
                    >
                        <UpdateRecurrenceConfirmationModal
                            cancelChanges={() => { this.setState({ openModalRecurrenceUpdate: false }); this.props.closeDialog() }}
                            close={() => this.setState({ openModalRecurrenceUpdate: false })}
                            applyOneOcurrence={() => this.setState({ recurrenceUpdate: false }, this.clickButtonSave())}
                            applyAllOcurrences={() => this.setState({ recurrenceUpdate: true }, this.clickButtonSave())}
                            dining={this.props.data}
                            timeZone={this.props.timeZone}
                        />
                    </Modal>

                    <Modal
                        open={this.state.openTranslationsModal}
                        onClose={() => this.setState({ openTranslationsModal: false, titleEs: '', titleFr: '', descriptionEs: '', descriptionFr: '' })}
                    >

                        <Paper elevation={3}>
                            <Grid className="translationsModal" >
                                <Grid className="ModalTitle">Add translations</Grid>
                                <Grid item container xs={12} style={{ marginTop: '1rem', marginBotton: '1rem' }}>
                                    <Tabs
                                        value={this.state.translationTab}
                                        onChange={this.handleChangeTab}
                                        aria-label="Translations tab dinings"
                                        className='translationTabs'
                                        TabIndicatorProps={{ style: { backgroundColor: '#009edd' } }}
                                        variant='fullWidth'
                                    >
                                        <Tab label="ES" className={(this.state.translationTab === 0) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(0)} />
                                        <Tab label="FR" className={(this.state.translationTab === 1) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(1)} />

                                    </Tabs>

                                    <SwipeableViews
                                        axis={'x'}
                                        index={this.state.translationTab}
                                        onChangeIndex={this.handleChangeTranslationIndex}
                                    >

                                        <TabPanel value={0} index={0} className='translationTabContent'>
                                            <Grid item container xs={12} style={{ marginTop: '1rem' }}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="GeneralInfo.titleEs"
                                                        label="Titulo"
                                                        maxLength={20}
                                                        onChange={(e, newItem) => this.OnTranslationChange(newItem, 'es', 'title')}
                                                        component={renderControledTextField}
                                                        valueToSet={this.state.titleEs ? this.state.titleEs : undefined}
                                                        id='Dining_Title_es'
                                                    />
                                                </Grid>
                                                <Grid item container alignContent='center' justifyContent='flex-end' style={{ paddingRight: '15px', color: '#686868' }}>
                                                    {
                                                        (this.state && this.state.titleEs && this.state.titleEs.length > 0) ?
                                                            <Grid item> {`${this.state.titleEs.length}/ 20`}</Grid>
                                                            :
                                                            undefined
                                                    }
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                                                    <Field
                                                        name="GeneralInfo.descriptionEs"
                                                        label="Descripción"
                                                        rows={4}
                                                        maxLength={20}
                                                        onChange={(e, newItem) => this.OnTranslationChange(newItem, 'es', 'description')}
                                                        component={renderControledTextField}
                                                        valueToSet={this.state.descriptionEs ? this.state.descriptionEs : undefined}
                                                        id='Dining_Description_es'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </TabPanel>

                                        <TabPanel value={1} index={1} className='translationTabContent'>
                                            <Grid item container xs={12} style={{ marginTop: '1rem' }}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="GeneralInfo.titleFr"
                                                        label="Titre"
                                                        maxLength={20}
                                                        onChange={(e, newItem) => this.OnTranslationChange(newItem, 'fr', 'title')}
                                                        component={renderControledTextField}
                                                        valueToSet={this.state.titleFr ? this.state.titleFr : undefined}
                                                        id='Dining_Title_fr'
                                                    />
                                                </Grid>
                                                <Grid item container alignContent='center' justifyContent='flex-end' style={{ paddingRight: '15px', color: '#686868' }}>
                                                    {
                                                        (this.state && this.state.titleFr && this.state.titleFr.length > 0) ?
                                                            <Grid item> {`${this.state.titleFr.length}/ 20`}</Grid>
                                                            :
                                                            undefined
                                                    }
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                                                    <Field
                                                        name="GeneralInfo.descriptionFr"
                                                        label="La description"
                                                        rows={4}
                                                        maxLength={20}
                                                        onChange={(e, newItem) => this.OnTranslationChange(newItem, 'fr', 'description')}
                                                        component={renderControledTextField}
                                                        valueToSet={this.state.descriptionFr ? this.state.descriptionFr : undefined}
                                                        id='Dining_Description_fr'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </TabPanel>

                                    </SwipeableViews>


                                </Grid>

                                <Grid item container xs={12} alignItems='center' justify='center' style={{ marginTop: '1rem' }}>
                                    <Grid
                                        id="cancel-translation-modal-button"
                                        item container justify='center' alignItems='center'
                                        onClick={() => this.setState({ openTranslationsModal: false })}
                                        className='RepairsModalButtonCancel alingCenter'
                                    >
                                        Cancel
                                    </Grid>
                                    <Grid
                                        id="ok-translation-modal-button"
                                        item container justify='center' alignItems='center'
                                        onClick={() => this.setState({ openTranslationsModal: false }, () => this.CheckValues())}
                                        className='RepairsModalButtonSchedule alingCenter'
                                    >
                                        Ok
                                    </Grid>
                                </Grid>



                            </Grid>
                        </Paper>
                    </Modal>
                    {
                        (this.state.openRecurrenceModal && this.state.dateStart) ?
                            <RecurrenceModal
                                inputObj={this.state.recurrenceObj ? this.state.recurrenceObj : { StartDate: this.state.dateStart }}
                                openModal={this.state.openRecurrenceModal}
                                onCloseModalHandler={this.onCloseRecurrenceModal}
                                onSaveFormHandler={this.onSaveRecurrenceFormHandler}
                                selectedRepeatValue={this.state.RepeatValue}
                            />
                            :
                            undefined
                    }

                    <Modal
                        open={this.state.openSearchModal}
                        style={{ borderRadius: '16px' }}
                        onClose={this.handleCancelImage}
                    >

                        <ImagesModal
                            onDone={this.handleSelectImage}
                            onCancel={this.handleCancelImage}
                            currentSearch={this.state.imageSearch}
                            changeSearch={this.handleChangeSearch}
                        />

                    </Modal>

                </form>
            </div>
        );
    };

};

function mapStateToProps(state, ownProps) {

    const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData : [];
    communityData = communityId ? communityData.find(item => item.communityId === communityId) : communityData[0];
    const allLocations = (state.diningLocationReducer?.diningLocationData) ? state.diningLocationReducer.diningLocationData : [];

    const locationData = (state.diningLocationReducer?.diningLocationData) ? state.diningLocationReducer.diningLocationData.filter(i => i.disableActions === false) : [];


    let initialValuesData = {};
    let mealsData = (state.communityReducer && state.communityReducer.mealsData) ? state.communityReducer.mealsData : [];
    let mealSuccess = state.diningReducer;

    //mealsData = mealsData.map( item => ({...item, timeStart: (item.timeStart? new Date(item.timeStart): new Date()), timeEnd: (item.timeEnd? new Date(item.timeEnd): new Date())    }))
    mealsData = mealsData.map(item => ({
        ...item,
        timeStart: (item.timeStart ? new Date(new Date(item.timeStart).toLocaleString("en-US", { timeZone: communityData.timeZoneName })) : new Date()),
        timeEnd: (item.timeEnd ? new Date(new Date(item.timeEnd).toLocaleString("en-US", { timeZone: communityData.timeZoneName })) : new Date())
    }))


    if (state.diningReducer && state.diningReducer.diningData && state.diningReducer.diningData.data) {
        initialValuesData._id = state.diningReducer.diningData.data._id
        initialValuesData.name = state.diningReducer.diningData.data.name
    }

    return {
        diningData: state.diningReducer && state.diningReducer.diningData,
        initialValues: initialValuesData,
        items: state.itemReducer.diningData,
        itemsByDining: [],
        mealsData: mealsData,
        isMealSuccess: mealSuccess,
        locationData,
        allLocations
    };
}

export default connect(mapStateToProps, { AddDining, UpdDining, AddDiningImage, getCommunityByIdAsync, GetCommunityMealTypes, GetPixabyImages, ClearImages, GetDiningLocations })(reduxForm({
    form: 'DiningForm',
    validate,
    enableReinitialize: true,
})(AddEditDining));